var _path, _g, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 60,
    viewBox: "0 0 160 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2062_98)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2062_98",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28882e-05 0H74.6096V60H2.28882e-05V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2062_98)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0477 -0.0377808L29.4709 0.931979V4.71032L33.0477 3.82873V-0.0377808Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1032 1.54913L23.8286 2.39294V5.75568L27.1032 4.9874V1.54913Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8009 2.87152L18.8286 3.57681V6.51134L21.8009 5.86901V2.87152Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.015 4.00503L14.345 4.59697V7.11587L17.015 6.57431V3.97986",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6447 5L10.2896 5.50377V7.68263L12.6447 7.22921V5Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62712 5.84381L6.57422 6.2468V8.08562L8.62712 7.70777V5.84381Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9117 6.59949L3.14844 6.92696V8.46348L4.9117 8.14862V6.59949Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44827 7.2796L-0.0126953 7.53151V8.79095L1.44827 8.55165V7.29221",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0477 6.25946L29.4709 7.07809V10.8564L33.0477 10.1385V6.25946Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1032 7.51886L23.8286 8.19897V11.5617L27.1032 10.9446V7.51886Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8009 8.63983L18.8286 9.21917V12.1411L21.8009 11.6247V8.63983Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.015 9.55917L14.345 10.0252V12.5441L17.015 12.1285V9.534",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6447 10.34C11.8639 10.4786 11.0704 10.6171 10.2896 10.7305V12.9219L12.6447 12.5567V10.34Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62712 11.0327L6.57422 11.3476V13.1864L8.62712 12.8967V11.0327Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9117 11.6247L3.14844 11.8892V13.4005L4.9117 13.1738V11.6247Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44827 12.1536C0.957082 12.2166 0.478488 12.2922 -0.0126953 12.3425V13.602L1.44827 13.4257V12.1662",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0477 12.5567L29.4709 13.2242V17.0025L33.0477 16.4357V12.5567Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1032 13.539L23.8286 14.0932V17.4433L27.1032 16.9773V13.539Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8009 14.3829C20.8185 14.5466 19.8236 14.6977 18.8286 14.8363V17.7708L21.8009 17.393V14.3829Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.015 15.0756L14.345 15.4408V17.9597L17.015 17.6448V15.0756Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6447 15.7053L10.2896 15.995V18.1738L12.6447 17.9219V15.7053Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62712 16.2216L6.57422 16.4483V18.2871L8.62712 18.0856V16.2216Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9117 16.6499L3.14844 16.8262V18.3501L4.9117 18.199V16.6499Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44827 17.0277L-0.0126953 17.1662V18.4257C0.478488 18.4257 0.957082 18.3627 1.44827 18.3123V17.0529",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0477 18.7405C31.7882 18.9169 30.6547 19.0932 29.4709 19.2443V23.0226C30.6547 22.9093 31.8512 22.7707 33.0477 22.6196V18.7028",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1032 19.534L23.8286 19.937V23.2872L27.1032 22.9597V19.534Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8009 20.1133L18.8286 20.4408V23.3627L21.8009 23.1108V20.1133Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.015 20.6549L14.345 20.9068V23.4257C15.2392 23.3627 16.1334 23.3124 17.015 23.2368V20.6423",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6447 21.0705L10.2896 21.2594V23.4383L12.6447 23.2871V21.0705Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62712 21.3728L6.57422 21.5113V23.3627L8.62712 23.2494V21.3728Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9117 21.675L3.14844 21.7758V23.2997L4.9117 23.2242V21.675Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44827 21.9018L-0.0126953 21.9648V23.2242H1.44827V21.9648",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0477 24.9874C31.7882 25.1259 30.6547 25.2267 29.4709 25.34V29.1184L33.0477 28.8539V24.937",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1032 25.5164L23.8286 25.7809V29.131L27.1032 28.9547V25.5164Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8009 25.9068C20.8185 25.9824 19.8236 26.0453 18.8286 26.0957V29.0302L21.8009 28.9169V25.9068Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.015 26.209L14.345 26.3476V28.8665L17.015 28.7909V26.1964",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6447 26.4106L10.2896 26.5113V28.6776H12.6447V26.4106Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62712 26.5995H6.57422V28.4383H8.62712V26.5743",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9117 26.7128H3.14844V28.2368H4.9117V26.7003",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44827 26.7758H-0.0126953V28.0353H1.44827V26.7758Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0477 31.2343L29.4709 31.4358V35.2141C30.6547 35.2141 31.8512 35.2141 33.0477 35.1134V31.1965",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1032 31.5113C26.0075 31.5113 24.9243 31.5995 23.8286 31.6247V34.9874H27.1032V31.5617",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8009 31.675H18.8286V34.6096H21.8009V31.6121",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.015 31.7506C16.1334 31.7506 15.2392 31.7506 14.345 31.7506V34.2695H17.015V31.6625",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6447 31.7884H10.2896V33.9672H12.6447V31.7506",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62712 31.7884H6.57422V33.6398L8.62712 33.7028V31.8388",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9117 31.7254H3.14844V33.2494L4.9117 33.3249V31.7758",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44827 31.6625L-0.0126953 31.5995V32.8589L1.44827 32.9471V31.6877",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0477 37.4811H29.4709V41.2595C30.6547 41.2595 31.8512 41.2595 33.0477 41.2595V37.3426",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1032 37.4937C26.0075 37.4937 24.9243 37.4937 23.8286 37.4937V40.8564L27.1032 40.9572V37.4937Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8009 37.4307L18.8286 37.3678V40.2645L21.8009 40.3904V37.3929",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.015 37.3048L14.345 37.2166V39.7355L17.015 39.8992V37.2922",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6447 37.1536L10.2896 37.0403V39.2191L12.6447 39.3703V37.1536Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62712 36.9648L6.57422 36.8388V38.6776L8.62712 38.8413V36.9648Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9117 36.7632L3.14844 36.6247V38.1486L4.9117 38.2997V36.7632Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44827 36.4862L-0.0126953 36.3602V37.6196L1.44827 37.7582V36.4988",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0477 43.728C31.7882 43.728 30.6547 43.665 29.4709 43.6146V47.393C30.6547 47.4811 31.8512 47.5441 33.0477 47.5945V43.6776",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1032 43.4886L23.8286 43.3123V46.675L27.1032 46.927V43.4886Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8009 43.1864L18.8286 42.9975V45.9194L21.8009 46.1839V43.1864Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.015 42.859L14.345 42.6449V45.1638L17.015 45.4282V42.8338",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6447 42.5189L10.2896 42.2922V44.471L12.6447 44.7355V42.5189Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62712 42.1536L6.57422 41.9395V43.7783L8.62712 44.0302V42.1536Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9117 41.7884L3.14844 41.5869V43.0982L4.9117 43.3249V41.7884Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44827 41.4106C0.957082 41.4106 0.478488 41.2847 -0.0126953 41.2217V42.4811L1.44827 42.6826V41.4232",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0477 49.9748C31.7882 49.8992 30.6547 49.8111 29.4709 49.7103V53.4887L33.0477 53.8413V49.9244",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1032 49.4836L23.8286 49.1688V52.5189L27.1032 52.9219V49.4836Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8009 48.9421L18.8286 48.6272V51.5995C19.8236 51.738 20.8185 51.8766 21.8009 51.9899V48.9924",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.015 48.4131L14.345 48.0856V50.6045L17.015 50.9824V48.3879",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6447 47.8211L10.2896 47.5063V49.6851L12.6447 50.0504V47.8211Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62712 47.3426L6.57422 47.0403V48.8791C7.25432 48.9924 7.94702 49.0932 8.62712 49.2191V47.3426Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9117 46.8136L3.14844 46.5239V48.0605L4.9117 48.3501V46.8136Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44827 46.2846L-0.0126953 46.0327V47.2922C0.478488 47.3929 0.957082 47.4811 1.44827 47.5567V46.2972",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0477 56.2217C31.7882 56.0957 30.6547 55.9572 29.4709 55.806V59.5844L33.0477 60.1007V56.1713",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1032 55.466C26.0075 55.3275 24.9243 55.1637 23.8286 55.0126V58.3753L27.1032 58.9043V55.466Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8009 54.6977L18.8286 54.2569V57.1914L21.8009 57.6952V54.6977Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.015 53.9672L14.345 53.5138V56.0327L17.015 56.5365V53.942",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6447 53.2367L10.2896 52.8085V54.9874L12.6447 55.4534V53.2367Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62712 52.5315L6.57422 52.1285V53.9673L8.62712 54.4081V52.5315Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9117 51.8388L3.14844 51.4861V52.9975L4.9117 53.3753V51.8388Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44827 51.1587L-0.0126953 50.8438V52.1033L1.44827 52.4307V51.1713",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8159 32.7078C40.0741 28.5167 42.2989 24.6795 45.3111 21.5054C48.3234 18.3313 52.0389 15.9089 56.1585 14.4332C49.6975 20.6675 44.1811 26.7506 38.8159 32.7078Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9116 33.8791C45.1132 29.7859 62.884 23.6524 73.8537 26.5365C62.3517 28.0157 50.9966 30.4721 39.9116 33.8791Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4634 35.4912C53.4382 36.5239 66.3097 39.4836 74.6095 48.6776C62.9999 43.5 52.9999 38 38.4634 35.4912Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7356 60.0752L37.1946 59.5205C37.9628 55.3314 38.2839 49.1705 37.7327 39.1436C40.3791 45.2611 41.8174 51.8124 41.9915 58.4385L66.7884 52.8467V42.4248C59.0815 38.0038 49.3257 36.2403 38.4632 35.4912C50.8283 31.6827 60.2855 32.1692 66.7884 37.1094V25.7969C56.4188 25.9722 44.0965 30.5856 39.9114 33.8789C45.6755 24.8393 57.471 20.2086 66.7884 22.7002V7.53125L34.7356 0V60.0752ZM39.5843 37.8467C47.2417 38.8542 51.8635 44.0429 54.055 52.5693C49.1432 47.9347 44.2693 43.1362 39.5843 37.8467ZM49.7278 39.3203C56.4869 41.0151 60.432 44.2792 61.053 49.3926C57.0981 45.5382 53.377 42.2373 49.7278 39.3203ZM38.8157 32.708C40.2389 19.5091 48.4381 13.1238 56.1585 14.4336C52.039 15.9093 48.323 18.3318 45.3108 21.5059C42.2988 24.6799 40.0738 28.5171 38.8157 32.708Z",
    fill: "#14474B"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3362 22.5967H80.7321V27.246C80.7321 28.1587 80.8082 28.9479 80.9603 29.6134C81.1125 30.298 81.3692 30.8589 81.7305 31.2963C82.0918 31.7337 82.5766 32.0569 83.1851 32.2661C83.8127 32.4753 84.5828 32.5798 85.4955 32.5798C86.4463 32.5798 87.2355 32.4848 87.863 32.2946C88.4905 32.1235 88.9849 31.8382 89.3462 31.4389C89.7075 31.0396 89.9547 30.5167 90.0878 29.8701C90.2399 29.2236 90.316 28.425 90.316 27.4742V20.0296H92.7119V27.5883H95.0223C95.4026 27.5883 95.6879 27.6453 95.878 27.7594C96.0682 27.8545 96.1632 28.1017 96.1632 28.501C96.1632 28.9764 96.0682 29.2807 95.878 29.4138C95.7069 29.5279 95.4216 29.5849 95.0223 29.5849H92.5408C92.2365 31.3343 91.5044 32.5989 90.3445 33.3785C89.1845 34.1771 87.5492 34.5765 85.4385 34.5765C84.1454 34.5765 83.0425 34.4244 82.1298 34.1201C81.2361 33.8159 80.504 33.369 79.9335 32.7795C79.382 32.209 78.9732 31.496 78.707 30.6403C78.4598 29.8036 78.3362 28.8338 78.3362 27.7309V22.5967ZM84.0123 17.4055C84.0123 16.9871 84.1549 16.6353 84.4402 16.3501C84.7444 16.0458 85.1057 15.8937 85.5241 15.8937C85.9424 15.8937 86.2942 16.0458 86.5794 16.3501C86.8837 16.6353 87.0358 16.9871 87.0358 17.4055C87.0358 17.8238 86.8837 18.1851 86.5794 18.4893C86.2942 18.7746 85.9424 18.9172 85.5241 18.9172C85.1057 18.9172 84.7444 18.7746 84.4402 18.4893C84.1549 18.1851 84.0123 17.8238 84.0123 17.4055ZM95.0089 29.5849C94.6286 29.5849 94.3434 29.5183 94.1532 29.3852C93.9631 29.2521 93.868 28.9859 93.868 28.5866C93.868 28.1112 93.9631 27.826 94.1532 27.7309C94.3244 27.6358 94.6096 27.5883 95.0089 27.5883H97.0056C97.7852 27.5883 98.2891 27.4171 98.5173 27.0749C98.7455 26.7136 98.8596 26.1336 98.8596 25.3349V17.4625H101.256V26.6185C101.256 26.7896 101.322 26.9417 101.455 27.0749C101.588 27.1889 101.75 27.284 101.94 27.3601C102.149 27.4361 102.368 27.4932 102.596 27.5312C102.824 27.5693 103.024 27.5883 103.195 27.5883H103.937C104.317 27.5883 104.602 27.6453 104.792 27.7594C104.983 27.8545 105.078 28.1017 105.078 28.501C105.078 28.9764 104.983 29.2807 104.792 29.4138C104.621 29.5279 104.336 29.5849 103.937 29.5849H103.423C102.872 29.5849 102.377 29.4993 101.94 29.3282C101.522 29.138 101.16 28.8148 100.856 28.3584C100.628 28.6626 100.267 28.9479 99.7723 29.2141C99.2779 29.4613 98.5363 29.5849 97.5475 29.5849H95.0089ZM96.5492 33.1788C96.5492 32.7605 96.6918 32.3992 96.977 32.0949C97.2813 31.8097 97.6426 31.6671 98.0609 31.6671C98.4793 31.6671 98.8311 31.8097 99.1163 32.0949C99.4205 32.3992 99.5727 32.7605 99.5727 33.1788C99.5727 33.5972 99.4205 33.949 99.1163 34.2342C98.8311 34.5384 98.4793 34.6906 98.0609 34.6906C97.6426 34.6906 97.2813 34.5384 96.977 34.2342C96.6918 33.949 96.5492 33.5972 96.5492 33.1788ZM100.257 33.1788C100.257 32.7605 100.4 32.3992 100.685 32.0949C100.989 31.8097 101.351 31.6671 101.769 31.6671C102.187 31.6671 102.539 31.8097 102.824 32.0949C103.129 32.3992 103.281 32.7605 103.281 33.1788C103.281 33.5972 103.129 33.949 102.824 34.2342C102.539 34.5384 102.187 34.6906 101.769 34.6906C101.351 34.6906 100.989 34.5384 100.685 34.2342C100.4 33.949 100.257 33.5972 100.257 33.1788ZM103.95 29.5849C103.57 29.5849 103.285 29.5183 103.095 29.3852C102.904 29.2521 102.809 28.9859 102.809 28.5866C102.809 28.1112 102.904 27.826 103.095 27.7309C103.266 27.6358 103.551 27.5883 103.95 27.5883H108.2C108.581 27.5883 108.866 27.6453 109.056 27.7594C109.246 27.8545 109.341 28.1017 109.341 28.501C109.341 28.9764 109.246 29.2807 109.056 29.4138C108.885 29.5279 108.6 29.5849 108.2 29.5849H103.95ZM108.184 29.5849C107.804 29.5849 107.519 29.5183 107.329 29.3852C107.138 29.2521 107.043 28.9859 107.043 28.5866C107.043 28.1112 107.138 27.826 107.329 27.7309C107.5 27.6358 107.785 27.5883 108.184 27.5883H112.434C112.815 27.5883 113.1 27.6453 113.29 27.7594C113.48 27.8545 113.575 28.1017 113.575 28.501C113.575 28.9764 113.48 29.2807 113.29 29.4138C113.119 29.5279 112.834 29.5849 112.434 29.5849H108.184ZM112.418 29.5849C112.038 29.5849 111.753 29.5183 111.562 29.3852C111.372 29.2521 111.277 28.9859 111.277 28.5866C111.277 28.1112 111.372 27.826 111.562 27.7309C111.734 27.6358 112.019 27.5883 112.418 27.5883H116.668C117.048 27.5883 117.334 27.6453 117.524 27.7594C117.714 27.8545 117.809 28.1017 117.809 28.501C117.809 28.9764 117.714 29.2807 117.524 29.4138C117.353 29.5279 117.067 29.5849 116.668 29.5849H112.418ZM131.655 26.6185C131.655 26.7896 131.722 26.9417 131.855 27.0749C131.988 27.1889 132.15 27.284 132.34 27.3601C132.53 27.4361 132.739 27.4932 132.967 27.5312C133.196 27.5693 133.395 27.5883 133.566 27.5883H134.108C134.489 27.5883 134.774 27.6453 134.964 27.7594C135.154 27.8545 135.249 28.1017 135.249 28.501C135.249 28.9764 135.154 29.2807 134.964 29.4138C134.793 29.5279 134.508 29.5849 134.108 29.5849H133.795C133.243 29.5849 132.749 29.4993 132.311 29.3282C131.893 29.138 131.532 28.8148 131.228 28.3584C130.999 28.6626 130.638 28.9479 130.144 29.2141C129.649 29.4613 128.908 29.5849 127.919 29.5849H116.652C116.272 29.5849 115.987 29.5183 115.796 29.3852C115.606 29.2521 115.511 28.9859 115.511 28.5866C115.511 28.1112 115.606 27.826 115.796 27.7309C115.968 27.6358 116.253 27.5883 116.652 27.5883H127.377C128.156 27.5883 128.66 27.4171 128.889 27.0749C129.117 26.7136 129.231 26.1336 129.231 25.3349V24.4792C129.231 23.4904 129.107 22.6632 128.86 21.9977C128.632 21.3322 128.271 20.8092 127.776 20.4289C127.301 20.0486 126.673 19.7824 125.894 19.6303C125.133 19.4591 124.23 19.3736 123.184 19.3736H118.221V17.4625L126.293 8.81995L127.862 10.2746L121.187 17.4625H123.355C124.667 17.4625 125.837 17.5766 126.863 17.8048C127.89 18.014 128.755 18.3657 129.459 18.8601C130.182 19.3545 130.724 20.0201 131.085 20.8568C131.465 21.6935 131.655 22.7393 131.655 23.9943V26.6185ZM139.137 31.9523C139.023 31.7051 138.871 31.3724 138.681 30.954C138.51 30.5547 138.319 30.0983 138.11 29.5849H134.089C133.708 29.5849 133.423 29.5183 133.233 29.3852C133.043 29.2521 132.948 28.9859 132.948 28.5866C132.948 28.1112 133.043 27.826 133.233 27.7309C133.404 27.6358 133.689 27.5883 134.089 27.5883H137.483C137.388 27.208 137.312 26.8276 137.255 26.4473C137.217 26.067 137.198 25.6772 137.198 25.2779C137.198 24.4982 137.331 23.7661 137.597 23.0816C137.863 22.378 138.253 21.7695 138.766 21.2561C139.28 20.7427 139.917 20.3338 140.677 20.0296C141.438 19.7253 142.303 19.5732 143.273 19.5732C144.357 19.5732 145.27 19.7539 146.011 20.1152C146.753 20.4765 147.352 20.9519 147.808 21.5413C148.265 22.1118 148.588 22.7583 148.778 23.4809C148.987 24.1845 149.092 24.8786 149.092 25.5631C149.092 26.2857 149.006 26.9608 148.835 27.5883H151.088C151.469 27.5883 151.754 27.6453 151.944 27.7594C152.134 27.8545 152.229 28.1017 152.229 28.501C152.229 28.9764 152.134 29.2807 151.944 29.4138C151.773 29.5279 151.488 29.5849 151.088 29.5849H147.951C147.456 30.3075 146.829 30.878 146.068 31.2963C145.327 31.7337 144.433 31.9523 143.387 31.9523H139.137ZM143.13 29.9557C143.739 29.9557 144.262 29.8321 144.699 29.5849C145.137 29.3187 145.498 28.9859 145.783 28.5866C146.068 28.1682 146.277 27.7024 146.411 27.1889C146.544 26.6565 146.61 26.1336 146.61 25.6202C146.61 24.4032 146.316 23.4144 145.726 22.6537C145.156 21.8741 144.309 21.4843 143.187 21.4843C142.75 21.4843 142.313 21.5603 141.875 21.7125C141.457 21.8456 141.086 22.0738 140.763 22.397C140.44 22.7013 140.173 23.1006 139.964 23.595C139.774 24.0894 139.679 24.6789 139.679 25.3635C139.679 25.8579 139.717 26.3332 139.793 26.7896C139.888 27.227 139.993 27.6453 140.107 28.0446C140.24 28.444 140.373 28.8053 140.506 29.1285C140.639 29.4518 140.763 29.7275 140.877 29.9557H143.13ZM151.053 29.5849C150.672 29.5849 150.387 29.5183 150.197 29.3852C150.007 29.2521 149.912 28.9859 149.912 28.5866C149.912 27.921 150.292 27.5883 151.053 27.5883H154.618V17.4625H157.014V29.5849H151.053ZM152.393 13.6689C152.393 13.2506 152.536 12.8988 152.821 12.6135C153.125 12.3093 153.487 12.1572 153.905 12.1572C154.323 12.1572 154.675 12.3093 154.96 12.6135C155.265 12.8988 155.417 13.2506 155.417 13.6689C155.417 14.0872 155.265 14.4485 154.96 14.7528C154.675 15.038 154.323 15.1806 153.905 15.1806C153.487 15.1806 153.125 15.038 152.821 14.7528C152.536 14.4485 152.393 14.0872 152.393 13.6689ZM156.101 13.6689C156.101 13.2506 156.244 12.8988 156.529 12.6135C156.833 12.3093 157.195 12.1572 157.613 12.1572C158.031 12.1572 158.383 12.3093 158.668 12.6135C158.973 12.8988 159.125 13.2506 159.125 13.6689C159.125 14.0872 158.973 14.4485 158.668 14.7528C158.383 15.038 158.031 15.1806 157.613 15.1806C157.195 15.1806 156.833 15.038 156.529 14.7528C156.244 14.4485 156.101 14.0872 156.101 13.6689Z",
    fill: "#14474B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.874 38.7688H87.3364V40.1882H83.4162V50.9347H81.7941V40.1882H77.874V38.7688ZM87.9823 50.9347L89.334 42.8241C89.4917 41.9229 89.7396 41.1626 90.0775 40.543C90.4267 39.9122 90.9336 39.4391 91.5983 39.1237C92.2741 38.797 93.1753 38.6336 94.3018 38.6336C94.7073 38.6336 95.1128 38.6562 95.5184 38.7012C95.9352 38.735 96.3632 38.8026 96.8026 38.904L96.8363 39.1068C96.8026 39.3321 96.7744 39.6137 96.7519 39.9516C96.7406 40.2896 96.735 40.6275 96.735 40.9654C96.735 41.3034 96.735 41.585 96.735 41.8103V50.9347H95.1128V47.2174H90.2634L89.6382 50.9347H87.9823ZM90.99 42.8241L90.4999 45.798H95.1128V40.9316C95.1128 40.7852 95.1128 40.6444 95.1128 40.5092C95.1128 40.374 95.1185 40.2445 95.1297 40.1206C95.0058 40.0981 94.865 40.0812 94.7073 40.0699C94.5609 40.0586 94.4032 40.053 94.2342 40.053C93.4907 40.053 92.8993 40.1544 92.46 40.3571C92.0319 40.5599 91.7053 40.8641 91.48 41.2696C91.2659 41.6751 91.1026 42.1933 90.99 42.8241ZM100.488 50.9347V38.7688H101.84L105.794 44.9363L109.748 38.7688H111.099V50.9347H109.477V42.0638L106.436 46.7442H105.152L102.11 42.0638V50.9347H100.488ZM114.856 50.9347V38.7688H116.478V44.7842H117.695C118.269 44.7842 118.703 44.649 118.996 44.3787C119.3 44.1083 119.542 43.7704 119.722 43.3648L121.885 38.7688H123.575V38.904L121.209 43.8379C121.074 44.1308 120.916 44.4068 120.736 44.6659C120.567 44.9137 120.37 45.1447 120.145 45.3587L123.609 50.7995V50.9347H121.784L118.793 46.0684C118.477 46.1585 118.134 46.2035 117.762 46.2035H116.478V50.9347H114.856ZM126.352 50.9347V38.7688H134.058V40.1882H127.975V43.8379H133.111V45.2573H127.975V49.5154H134.26V50.9347H126.352ZM137.272 50.9347V38.7688H144.977V40.1882H138.894V43.8379H144.03V45.2573H138.894V49.5154H145.179V50.9347H137.272ZM148.191 50.9347V38.7688H149.542L155.761 45.3249V38.7688H157.383V50.9347H155.761V47.6229L149.813 41.3372V50.9347H148.191Z",
    fill: "#14474B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2062_98"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a297d7c9d8ac7f126f5faff9f3ee14bd.svg";
export { ForwardRef as ReactComponent };